import type { Course } from "@brookbush/types";

import { CoinsIcon } from "lucide-react";

import CourseExamDifficulty from "./CourseExamDifficulty";

interface Props {
	course: Course;
}

const CourseInfoPreview = ({ course }: Props) => {
	return (
		<div className="-mb-2.5 flex items-center justify-between gap-2">
			<span className="flex items-center gap-2 font-semibold text-emerald-700 dark:text-emerald-400">
				<CoinsIcon className="size-5" />
				{course.credits} Credit{course.credits > 1 ? "s" : ""}
			</span>

			<CourseExamDifficulty finalExamDifficulty={course.finalExamDifficulty} />
		</div>
	);
};

export default CourseInfoPreview;
